import React from 'react'

class Dummy extends React.Component {
  render() {
    return <div className="dummy"></div>
  }
}

export default Dummy
